import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Material UI
import {
  Alert,
  Avatar,
  Box,
  Button,
  Collapse,
  IconButton,
  InputAdornment,
  TextField,
  Typography
} from '@mui/material';
import {
  Link
} from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { useAuth } from '../../Contexts/AuthContext';
import PageLayout from '../../Components/PageLayout/PageLayout';


export default function SignIn() {
  // const dataContext = useContext(DataContext);
  const auth = useAuth();
  const location = useLocation();

  const [show, setShow] = useState({
    password: false,
  });
  const [errors, setErrors] = useState({
    email: false,
    login: false,
    password: false,
  });
  const [errorMessage, setErrorMessage] = useState('');

  // Show a banner if the user was redirected here due to an expired session
  const sessionExpired = useMemo(
    () => new URLSearchParams(location.search).get('reason') === 'session_expired',
    [location.search]
  );

  // const {
  //   activeUser,
  // } = dataContext;

  // useEffect(() => {
  //   if(activeUser.accessToken.length > 0){
      // const decodedToken = jwt_decode(auth.activeUser.accessToken);
      // console.log("decodedToken", decodedToken);
  //   }
  // }, [activeUser]) 

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    // Clear any previous login errors when a new attempt is made
    setErrors({
      email: false,
      login: false,
      password: false,
    });
    setErrorMessage('');
    
    const data = new FormData(event.currentTarget);
    const email = data.get('email');
    const password = data.get('password');
    const fieldsValid = validateFields(email, password);
    if(fieldsValid){
      const success = await auth.login(email, password);
      if(!success){
        setErrors({
          email: false,
          login: true,
          password: false,
        });
        setErrorMessage("Login failed. Please check your email address and password, and try again.");
      }
    }
  };

  const validateFields = (email, password) => {
    let invalidFields = [];
    const emailValidation = String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    if(!emailValidation){
      invalidFields.push('email');
    }
    if(!password){
      invalidFields.push('password');
    }

    if(invalidFields.length === 0){
      return true;
    }
    else{
      let newErrors = {};
      invalidFields.forEach((field) => {
        newErrors[field] = true;
      });
      setErrors(newErrors);
      return false;
    }
  }

  return (
    <PageLayout maxWidth="xs">
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          marginTop: 8,
        }}
      >
        <Avatar 
          sx={{
            m: 1, 
            bgcolor: 'primary.main' 
          }}
        >
          <LockOutlinedIcon />
        </Avatar>
          <Typography 
            component="h1" 
            sx={{}} 
            variant="h5"
          >
            Sign in
          </Typography>
          {sessionExpired && (
            <Alert severity="warning" sx={{ mt: 2, width: '100%' }}>
              Your session has expired. Please sign in again.
            </Alert>
          )}
          <Box 
            component="form" 
            onSubmit={handleSubmit}
            noValidate sx={{ mt: 1 }}
          >
            <TextField
              autoComplete="email"
              autoFocus
              error={errors.email}
              fullWidth
              helperText={errors.email ? "Please enter a valid email address" : ''}
              margin="normal"
              id="email"
              label="Email Address"
              name="email"
              required
            />
            <TextField
              autoComplete="current-password"
              error={errors.password}
              fullWidth
              helperText={errors.password ? "Please enter a valid password" : ''}
              id="password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setShow({...show, password: !show.password});
                      }}
                    >
                      {show.password ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              margin="normal"
              name="password"
              label="Password"
              type={show.password ? "text": "password"}
              required
            />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                verticalAlign: 'middle',
              }}
            >
              {/* <FormControlLabel
                control={<Checkbox
                            checked={rememberMe}
                            color="primary"
                            inputProps={{'aria-label': 'controlled'}}
                            onChange={() => setRememberMe(!rememberMe)}
                            value="remember"
                          />}
                label="Remember me" // TODO: Create extended cookie on "remember me" check
              /> */}
              <Link
                sx={{
                  // marginLeft: 'auto',
                  paddingTop: '10px',
                }}
                to="/forgot-password"
                variant="body2"
              >
                Forgot password?
              </Link>
            </Box>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Collapse 
              in={errors.login} //errors.login
              sx={{
                width: '100%'
              }}
            >
              <Alert 
                severity="error"
                sx={{
                  mt: '0.5rem',
                  textAlign: 'center',
                }}
              >
                {errorMessage}
              </Alert>
            </Collapse>
          </Box>
        </Box>
    </PageLayout>
  );
}

